// JOH World — audio: originele arcade-SFX (WebAudio-synthese) + muziek per level (mp3).
// Eén master mute/volume regelt zowel muziek als geluidseffecten.
let ctx = null;
let enabled = true;      // mute-knop
let volume = 0.8;        // master volume 0..1 (slider)

export function setSoundEnabled(v) {
  enabled = v;
  if (musicEl) musicEl.muted = !v;
}
export function soundEnabled() { return enabled; }
export function setMasterVolume(v) {
  volume = Math.max(0, Math.min(1, v));
  if (musicEl) musicEl.volume = volume * MUSIC_BASE;
}
export function masterVolume() { return volume; }

function ac() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

function tone(freq, dur, type = "square", vol = 0.12, when = 0, slide = 0) {
  if (!enabled) return;
  const c = ac();
  if (!c) return;
  const t0 = c.currentTime + when;
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.setValueAtTime(freq, t0);
  if (slide) o.frequency.exponentialRampToValueAtTime(Math.max(30, freq + slide), t0 + dur);
  g.gain.setValueAtTime(vol * volume, t0);
  g.gain.exponentialRampToValueAtTime(0.001, t0 + dur);
  o.connect(g).connect(c.destination);
  o.start(t0);
  o.stop(t0 + dur + 0.02);
}

function noise(dur, vol = 0.15, when = 0, lowpass = 1200) {
  if (!enabled) return;
  const c = ac();
  if (!c) return;
  const t0 = c.currentTime + when;
  const len = Math.max(1, Math.floor(c.sampleRate * dur));
  const buf = c.createBuffer(1, len, c.sampleRate);
  const d = buf.getChannelData(0);
  for (let i = 0; i < len; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / len);
  const src = c.createBufferSource();
  src.buffer = buf;
  const f = c.createBiquadFilter();
  f.type = "lowpass";
  f.frequency.setValueAtTime(lowpass, t0);
  const g = c.createGain();
  g.gain.setValueAtTime(vol * volume, t0);
  g.gain.exponentialRampToValueAtTime(0.001, t0 + dur);
  src.connect(f).connect(g).connect(c.destination);
  src.start(t0);
}

export const sfx = {
  select: () => tone(660, 0.07, "square", 0.08),
  // menu-varianten: kort, herkenbaar, elk met eigen karakter
  menuGo: () => { tone(523, 0.06, "square", 0.1); tone(784, 0.1, "square", 0.11, 0.05); }, // bevestigend omhoog
  menuBack: () => { tone(440, 0.06, "square", 0.09); tone(294, 0.1, "square", 0.09, 0.05); }, // omlaag (terug)
  menuBlip: () => tone(988, 0.05, "square", 0.08), // lichte blip
  menuCoin: () => { tone(988, 0.06, "square", 0.1); tone(1319, 0.14, "square", 0.1, 0.06); }, // vrolijke "coin"
  start: () => { tone(392, 0.09, "square", 0.1); tone(523, 0.09, "square", 0.1, 0.09); tone(784, 0.16, "square", 0.12, 0.18); },
  jump: () => tone(240, 0.18, "square", 0.09, 0, 420),
  land: () => { noise(0.07, 0.12, 0, 500); tone(90, 0.08, "triangle", 0.1); }, // stamp bij neerkomen
  step: () => noise(0.03, 0.05, 0, 900), // korte voetstap-tick
  duck: () => tone(180, 0.08, "triangle", 0.08, 0, -60),
  jab: () => { noise(0.06, 0.1, 0, 2500); tone(520, 0.05, "square", 0.07); },
  cross: () => { noise(0.1, 0.16, 0, 1800); tone(330, 0.09, "square", 0.1, 0, -80); },
  punchHit: () => { noise(0.12, 0.24, 0, 1400); tone(196, 0.1, "square", 0.14, 0, -60); tone(98, 0.12, "triangle", 0.12, 0.01); }, // krachtig raakgeluid
  hit: () => { noise(0.2, 0.2, 0, 900); tone(140, 0.22, "sawtooth", 0.12, 0, -70); },
  rockHit: () => { noise(0.08, 0.2, 0, 1100); tone(150, 0.07, "square", 0.11, 0, -30); }, // korte impact op obstakel
  rockBreak: () => { noise(0.28, 0.22, 0, 700); tone(98, 0.25, "square", 0.1, 0, -40); }, // obstakel verdwijnt volledig
  niceDuck: () => { tone(587, 0.08, "square", 0.09); tone(880, 0.12, "square", 0.09, 0.08); },
  levelStart: () => { tone(523, 0.08, "square", 0.11); tone(659, 0.08, "square", 0.11, 0.08); tone(784, 0.14, "square", 0.12, 0.16); }, // kort intro-signaal
  levelClear: () => { [523, 659, 784, 1046].forEach((f, i) => tone(f, 0.14, "square", 0.11, i * 0.12)); },
  gameOver: () => { [392, 330, 262, 196].forEach((f, i) => tone(f, 0.22, "square", 0.11, i * 0.18)); }, // afsluitend dalend
  pushup: () => tone(300, 0.06, "triangle", 0.09, 0, 120),
  pushupPass: () => { [440, 554, 659].forEach((f, i) => tone(f, 0.12, "square", 0.1, i * 0.1)); },
  pushupFail: () => { tone(220, 0.2, "sawtooth", 0.1); tone(165, 0.3, "sawtooth", 0.1, 0.18); },
  cleanCombo: () => { [659, 784, 988, 1319].forEach((f, i) => tone(f, 0.1, "square", 0.1, i * 0.08)); },
  wrongCombo: () => { tone(196, 0.16, "square", 0.11); tone(147, 0.26, "square", 0.11, 0.14); },
  bagHit: () => { noise(0.08, 0.16, 0, 1000); tone(110, 0.09, "triangle", 0.1); },
  warn: () => { tone(880, 0.09, "square", 0.09); tone(880, 0.09, "square", 0.09, 0.14); },
  newRecord: () => { [523, 659, 784, 1046, 1319, 1568].forEach((f, i) => tone(f, 0.12, "square", 0.11, i * 0.1)); },
  gameComplete: () => { [392, 523, 659, 784, 1046, 784, 1046, 1319].forEach((f, i) => tone(f, 0.15, "square", 0.1, i * 0.13)); },
};

/* ---------- Muziek per level (mp3) ---------- */
const MUSIC_BASE = 0.55; // muziek zachter dan SFX
const DEFAULT_TRACKS = {
  intro: "/johworld/music/intro.mp3",
  level1: "/johworld/music/level1.mp3",
  level2: "/johworld/music/level2.mp3",
  level3: "/johworld/music/level3.mp3",
  final: "/johworld/music/final.mp3",
};
let musicSlots = null;   // van backend (admin kan tracks vervangen)
let musicEl = null;
let currentSlot = null;
let fadeTimer = null;

export async function loadMusicSlots() {
  try {
    const base = process.env.REACT_APP_BACKEND_URL;
    const r = await fetch(`${base}/api/joh-world/music`);
    if (r.ok) musicSlots = (await r.json()).slots;
  } catch { /* defaults gebruiken */ }
}

function slotUrl(slot) {
  const custom = musicSlots?.[slot]?.url;
  return custom || DEFAULT_TRACKS[slot];
}

function clearFade() { if (fadeTimer) { clearInterval(fadeTimer); fadeTimer = null; } }

function fadeTo(target, ms, after) {
  clearFade();
  const el = musicEl;
  if (!el) return;
  const steps = 12;
  const from = el.volume;
  let i = 0;
  fadeTimer = setInterval(() => {
    i += 1;
    el.volume = Math.max(0, Math.min(1, from + (target - from) * (i / steps)));
    if (i >= steps) {
      clearFade();
      if (after) after();
    }
  }, ms / steps);
}

export function playMusic(slot) {
  if (currentSlot === slot && musicEl && !musicEl.paused) return;
  const url = slotUrl(slot);
  if (!url) return;
  currentSlot = slot;
  window.__jwMusic = slot; // test/debug-haak
  // Regel: de vorige track stopt VOLLEDIG voordat de nieuwe start — nooit overlap.
  if (musicEl) {
    try { musicEl.pause(); musicEl.src = ""; } catch { /* ignore */ }
    musicEl = null;
  }
  clearFade();
  musicEl = new Audio(url);
  musicEl.loop = true;
  musicEl.muted = !enabled;
  musicEl.volume = 0;
  const p = musicEl.play();
  if (p?.catch) {
    p.catch(() => {
      // autoplay-blokkade: probeer opnieuw bij eerste gebruikersgebaar (alleen als dit nog de actuele track is)
      const retry = () => { if (musicEl && currentSlot === slot) musicEl.play().catch(() => {}); };
      window.addEventListener("pointerdown", retry, { once: true });
      window.addEventListener("keydown", retry, { once: true });
    });
  }
  fadeTo(volume * MUSIC_BASE, 250);
}

export function stopMusic() {
  currentSlot = null;
  window.__jwMusic = null;
  if (!musicEl) return;
  try { musicEl.pause(); musicEl.src = ""; } catch { /* ignore */ }
  musicEl = null;
}

export function currentMusic() { return currentSlot; }
